export const integerNumber = {
  label: 'Número inteiro',
  description: 'Exemplo: 1',
  value: 'numberInteger',
}
export const realNumberPlaceOne = {
  label: 'Número real 1',
  description: 'Exemplo: 1.5',
  value: 'numberReal1',
}

export const realNumber = {
  label: 'Número real 2',
  description: 'Exemplo: 1.50',
  value: 'numberReal',
}
export const realNumberPlaceThree = {
  label: 'Número real 3',
  description: 'Exemplo: 1.500',
  value: 'numberReal3',
}
export const realNumberPlaceFour = {
  label: 'Número real 4',
  description: 'Exemplo: 1.5000',
  value: 'numberReal4',
}

export const timePicker = {
  label: 'Tempo',
  description: 'Exemplos: 45 (seg), 1:30 (min:seg), 1:15:30 (h:min:seg)',
  value: 'minute',
}

export const brazilianReal = {
  label: 'BRL',
  description: 'Valor monetário, formato brasileiro',
  value: 'BRL',
}

export const percentage = {
  label: 'Porcentagem',
  description: 'Número real com %',
  value: 'percentage',
}

export default {
  realNumber,
  brazilianReal,
  percentage,
  timePicker,
}
